import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';
import Account from './Account';
import Container from './Container';
import Step1Login from './Step1Login';
import Loader from './Loader';
import { useOvermind } from '../../overmind'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  grid:{
    alignContent: 'center',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Sign in to Google', 'Select your Account', 'Select your Container'];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <Step1Login/>;
    case 1:
      return <Account/>;
    case 2:
      return <Container/>;
    default:
      return 'Unknown stepIndex';
  }
}

export default function HorizontalLabelPositionBelowStepper() {
  const classes = useStyles();
  const { state, actions } = useOvermind();
  const steps = getSteps();

  const handleNext = () => {
    actions.setActiveStep(state.activeStep + 1);
  };

  const handleBack = () => {
    actions.setActiveStep(state.activeStep - 1);
  };

  if(state.activeStep < steps.length ){
    return (
      <div className={classes.root}>
      <Grid container direction="column" justify="center" alignItems="center" spacing={2}>
       <Grid item xs={12} md={12} lg={12}>
        We just need a little more information before you can use GTM Docs!
       </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <Stepper activeStep={state.activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid item xs={12} md={12} lg={12} >
            {getStepContent(state.activeStep)}
        </Grid>
        <Grid item xs={12} md={12} lg={12} >
            <Button
              disabled={state.activeStep === 0}
              onClick={handleBack}
              className={classes.backButton}
            >
              Back
            </Button>
            <Button
              variant="contained"
              disabled={state.disableNextStepState[state.activeStep]}
              color="primary"
              onClick={handleNext}>
              {state.activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button>
        </Grid>
      </Grid>

      </div>
    );
}else{
  return(
    <Loader />
  );
}
}
